var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeakage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fill-icon{fill:currentColor;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leakage"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M87.26,40.26s-25.74,30.61-25.74,48a25.74,25.74,0,0,0,51.48,0C113,70.87,87.26,40.26,87.26,40.26Zm13.31,57.37a18.35,18.35,0,0,1-3.29,3.12L95.63,98.5a15.21,15.21,0,0,0,4.82-5.88L103,93.79A18.34,18.34,0,0,1,100.57,97.63Zm.09-10.77L89.53,67.39,92,66l11.13,19.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-icon",
    d: "M36.43,15.22S17,38.32,17,51.44a19.43,19.43,0,1,0,38.85,0C55.85,38.32,36.43,15.22,36.43,15.22Zm10,43.29A13.85,13.85,0,0,1,44,60.87l-1.25-1.7a11.32,11.32,0,0,0,2.1-2,11.49,11.49,0,0,0,1.54-2.45l1.9.89A13.5,13.5,0,0,1,46.47,58.51Zm.07-8.12-8.4-14.7,1.82-1,8.4,14.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeakage);
export default __webpack_public_path__ + "static/media/leakage.b84b0ebba8dfac227672fcf9fcb4667e.svg";
export { ForwardRef as ReactComponent };